import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

import { OverlayDialogPageModule } from './overlay-dialog/overlay-dialog.module';
import { ConfirmDialogPageModule } from './confirm-dialog/confirm-dialog.module';
import { KeyboardDialogPageModule } from './keyboard-dialog/keyboard-dialog.module';
import { InputDialogPageModule } from './input-dialog/input-dialog.module';
import { SCOPaymentDialogPageModule } from './sco-payment-dialog/sco-payment-dialog.module';
import { InfoDialogPageModule } from './info-dialog/info-dialog.module';
import { ListDialogPageModule } from './list-dialog/list-dialog.module';
import { SearchDialogPageModule } from './search-dialog/search-dialog.module';
import { FunctionDialogPageModule } from './function-dialog/function-dialog.module';
import { PaymentDialogPageModule } from './payment-dialog/payment-dialog.module';
import { WelcomeDialogPageModule } from './welcome-dialog/welcome-dialog.module';
import { PDFViewerDialogPageModule } from './pdf-viewer-dialog/pdf-viewer-dialog.module';
import { MaintenanceDialogPageModule } from './maintenance-dialog/maintenance-dialog.module';
import { CartDialogPageModule } from './cart-dialog/cart-dialog.module';
import { NumericInputDialogPageModule } from './numeric-input-dialog/numeric-input-dialog.module';
import { ProductDetailDialogPageModule } from './product-detail-dialog/product-detail-dialog.module';
import { CameraDialogPageModule } from './camera-dialog/camera-dialog.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ConfirmDialogPageModule,
    InfoDialogPageModule,
    InputDialogPageModule,
    KeyboardDialogPageModule,
    OverlayDialogPageModule,
    PaymentDialogPageModule,
    SCOPaymentDialogPageModule,
    ListDialogPageModule,
    SearchDialogPageModule,
    FunctionDialogPageModule,
    WelcomeDialogPageModule,
    PDFViewerDialogPageModule,
    ProductDetailDialogPageModule,
    MaintenanceDialogPageModule,
    CartDialogPageModule,
    NumericInputDialogPageModule,
    CameraDialogPageModule
  ],
  exports: [
    ConfirmDialogPageModule,
    InfoDialogPageModule,
    InputDialogPageModule,
    OverlayDialogPageModule,
    KeyboardDialogPageModule,
    PaymentDialogPageModule,
    SCOPaymentDialogPageModule,
    ListDialogPageModule,
    SearchDialogPageModule,
    FunctionDialogPageModule,
    WelcomeDialogPageModule,
    PDFViewerDialogPageModule,
    ProductDetailDialogPageModule,
    MaintenanceDialogPageModule,
    CartDialogPageModule,
    NumericInputDialogPageModule,
    CameraDialogPageModule
  ]
})
export class GUIDialogsModule { }
